import React, { PureComponent } from "react";
import { Widget } from "xav-chat-widget";
import "xav-chat-widget/lib/styles.css";
import SdsSurveyForm from './sdsSurveyForm';
import UberSurveyForm from './uberSurveyForm';
import { fetchChatSurveyConfigApi, fetchQueueList } from '../apis/botApi';
import { Navigate } from "react-router-dom";
import "./style.scss";
import WidgetContext from '../context/WidgetContext';
import PageLoader from '../components/common/PageLoader';
import { getItemFromSession, removeFromSession } from '../utils/common';
import { USER_DETAIL_SESSION_KEY, USER_TIME_SESSION_KEY, SESSION_RESTORE_DURATION, APP_CLIENTS } from '../utils/constants';
const { REACT_APP_BOT_ID, REACT_APP_CLIENT } = process.env;
class ChatSurvey extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      employeeId: '',
      email: '',
      preChatResponse: null,
      queueList: null,
      redirectRoute: false,
      showLoader: true
    };
    this.botUID=REACT_APP_BOT_ID;
  }

  async componentDidMount() {
    try {
      const relayState = getItemFromSession("relayStateOneLogin") || '';
      const empInfoResponse=await fetchChatSurveyConfigApi(this.botUID, relayState);
      const queueResponse=await fetchQueueList(this.botUID, relayState);
      const empInfoResult=empInfoResponse.data.result;
      const empInfo=this.getUsersInfo(empInfoResult);
      let queueResult=queueResponse.data.result;
      queueResult=queueResult.map((queue)=>{
        return {...queue, label: queue.name, value: queue.uid}
      })
      this.setState({name: empInfo.fullName, employeeId: empInfo.employeeId, email: empInfo.email, phone: empInfo.phone, queueList: queueResult, redirectRoute: false, showLoader: false });
      const sessionData = getItemFromSession(USER_DETAIL_SESSION_KEY);
      const sessionTime = getItemFromSession(USER_TIME_SESSION_KEY);
      const currentTime=new Date().getTime();
      if(sessionData && sessionTime && (currentTime - sessionTime <= SESSION_RESTORE_DURATION)){
          this.setState({
            preChatResponse: JSON.parse(sessionData)
          }, () =>{
            this.context.toggleWidgetContext(true);
          });
      }
    } catch (error) {
      console.log("Error in fetching details:::", error);
      this.setState({redirectRoute: true, showLoader: false});
    }
  }

  getUsersInfo=(empInfoResult)=>{
    const empInfo={};
    if(REACT_APP_CLIENT===APP_CLIENTS.lighthouse){
      empInfo.firstName = empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity ? empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity.firstName : '';
      empInfo.lastName = empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity ? empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity.lastName : '';
      empInfo.employeeId = empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity ? empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity.employeeId : '';
      empInfo.email = empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity ? empInfoResult.EmployeeIdentityInformationResponse.employeeIdentity.email : '';
      empInfo.fullName = `${empInfo.firstName} ${empInfo.lastName}`;
    }else if(REACT_APP_CLIENT===APP_CLIENTS.uber){
      empInfo.firstName = empInfoResult.firstName ? empInfoResult.firstName : '';
      empInfo.lastName = empInfoResult.lastName ? empInfoResult.lastName : '';
      empInfo.employeeId = empInfoResult.employeeIdentity ? empInfoResult.employeeId : '';
      empInfo.email = empInfoResult.email ? empInfoResult.email : '';
      empInfo.fullName = empInfo.firstName ? `${empInfo.firstName} ${empInfo.lastName}`: '';
      empInfo.phone=empInfoResult.phoneNo ? empInfoResult.phoneNo : '';
    }
    return empInfo;
  }

  resetPrechatResponse=()=>{
    this.setState({
      preChatResponse: null
    })
  }

  chatSurveyFormSubmitHandler = (response) => {
      this.context.toggleWidgetContext(true);
      this.setState({
        preChatResponse: response.result
      })
  };

  showHideLoader = (val) => {
    this.setState({
      showLoader: val
    });
  }
  
  chatToolEventListener=(event)=>{
    if(event){
      if(event.type=="CHAT_TOOL_AGENT_UNJOIN"){
        this.context.toggleWidgetContext(true, true);
      }else if(event.type=="CHAT_TOOL_CONNECTION_ERROR"){
        removeFromSession(USER_DETAIL_SESSION_KEY);
        removeFromSession(USER_TIME_SESSION_KEY);
      }
    }
  }

  renderChatSurvey(){
    const { name, employeeId, email, phone, queueList} = this.state;
    if(REACT_APP_CLIENT===APP_CLIENTS.lighthouse && name && employeeId){
      return <SdsSurveyForm 
                botId={this.botUID} 
                name={name} employeeId={employeeId} 
                email={email} queueList={queueList} 
                resetPrechatResponse={this.resetPrechatResponse} 
                chatSurveyFormSubmitHandler={this.chatSurveyFormSubmitHandler} 
                showHideLoader={this.showHideLoader}/>;
    }else if(REACT_APP_CLIENT===APP_CLIENTS.uber && email){
      return <UberSurveyForm 
                botId={this.botUID} 
                name={name} employeeId={employeeId} 
                email={email} queueList={queueList} 
                phone={phone}
                resetPrechatResponse={this.resetPrechatResponse} 
                chatSurveyFormSubmitHandler={this.chatSurveyFormSubmitHandler} 
                showHideLoader={this.showHideLoader}/>;
    }
  }

  render() {
    const { name, employeeId, email, preChatResponse, redirectRoute, showLoader} = this.state;
    const {isWidgetOpen}=this.context;
    if(redirectRoute){
      return <Navigate to='/home'/>;
    }
    return (
      <>
        {showLoader ? <PageLoader /> : null}
        {(isWidgetOpen && preChatResponse) ?
          <div className="widget-wrapper">
            <Widget
              chatToolEventListener={this.chatToolEventListener}
              customData={{
                botTogglerRequired: false,
                mainHeaderRequired: false,
                botNameRequired: false,
                fullScreenMode: true,
                additionalData: preChatResponse.settings.props,
                isChatTool: true,
                chatToolName: REACT_APP_CLIENT
              }}
              fullScreenMode={true}
              botID={this.botUID}
              user={{ tid: employeeId, displayName: name, email: email, phone: preChatResponse.settings.props.phone_number, defaultUser: preChatResponse.jid.split('@')[0], skill: preChatResponse.settings.props.queue }}
            />
          </div>
          :
          this.renderChatSurvey()
        }
      </>
    );
  }
}

ChatSurvey.contextType=WidgetContext;

export default ChatSurvey;
